import React from "react";

export const ArrowImg = () => (
  <svg
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L5 6L1 11"
      stroke="#9CA6A9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RoleIconImg = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="28" fill="#FFBC36" />
    <path
      d="M16.8545 35.124V37.2732C16.8545 37.7937 17.2764 38.2156 17.7969 38.2156H38.2031C38.7236 38.2156 39.1455 37.7937 39.1455 37.2732V35.124H16.8545Z"
      fill="white"
    />
    <path
      d="M44 23.1448C44 21.4658 42.634 20.0999 40.9551 20.0999C39.2761 20.0999 37.9104 21.4658 37.9104 23.1448C37.9104 23.9519 38.2266 24.6863 38.7412 25.2317C37.8259 26.2556 36.4968 26.9019 35.0188 26.9019C32.6262 26.9019 30.6223 25.2104 30.1375 22.9609C30.6973 22.4084 31.0449 21.6416 31.0449 20.7949C31.0449 19.116 29.679 17.75 28 17.75C26.321 17.75 24.9551 19.116 24.9551 20.7949C24.9551 21.6416 25.303 22.4084 25.8625 22.9609C25.3777 25.2104 23.3738 26.9019 20.9812 26.9019C19.5032 26.9019 18.1741 26.2556 17.2588 25.2317C17.7734 24.6863 18.0898 23.9519 18.0898 23.1448C18.0898 21.4658 16.7239 20.0999 15.0449 20.0999C13.366 20.0999 12 21.4658 12 23.1448C12 24.5999 13.0261 25.8191 14.3926 26.1184C14.6628 28.3489 15.1851 31.0664 16.1934 33.2388H39.8066C40.8149 31.0664 41.3372 28.3489 41.6074 26.1184C42.9739 25.8188 44 24.5999 44 23.1448Z"
      fill="white"
    />
  </svg>
);

export const CameraImg = ({ color = "white" }) => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 6.97266C9.4999 6.97266 6.65234 9.82021 6.65234 13.3203C6.65234 16.8204 9.4999 19.668 13 19.668C16.5001 19.668 19.3477 16.8204 19.3477 13.3203C19.3477 9.82021 16.5001 6.97266 13 6.97266ZM13 17.6367C10.6199 17.6367 8.68359 15.7004 8.68359 13.3203C8.68359 10.9402 10.6199 9.00391 13 9.00391C15.3801 9.00391 17.3164 10.9402 17.3164 13.3203C17.3164 15.7004 15.3801 17.6367 13 17.6367Z"
      fill={color}
    />
    <path
      d="M22.9531 3.92578H19.2169C19.0986 3.92578 18.992 3.86124 18.9372 3.75683L17.9035 1.58477C17.9007 1.57882 17.8979 1.57293 17.8949 1.56704C17.4947 0.76673 16.6903 0.269531 15.7955 0.269531H10.2769C9.38209 0.269531 8.57761 0.76673 8.17751 1.56709C8.17451 1.57298 8.17167 1.57888 8.16882 1.58482L7.13512 3.75698C7.08028 3.86124 6.97374 3.92578 6.85547 3.92578H3.04688C1.36683 3.92578 0 5.29261 0 6.97266V20.6836C0 22.3636 1.36683 23.7305 3.04688 23.7305H22.9531C24.6332 23.7305 26 22.3636 26 20.6836V6.97266C26 5.29261 24.6332 3.92578 22.9531 3.92578ZM23.9688 20.6835C23.9688 21.2436 23.5131 21.6992 22.9531 21.6992H3.04688C2.48686 21.6992 2.03125 21.2436 2.03125 20.6835V6.97266C2.03125 6.41264 2.48686 5.95703 3.04688 5.95703H6.85547C7.75023 5.95703 8.55471 5.45988 8.95487 4.65957C8.95786 4.65368 8.96071 4.64774 8.9636 4.6418L9.9973 2.46963C10.0521 2.36532 10.1586 2.30078 10.2769 2.30078H15.7955C15.9137 2.30078 16.0203 2.36532 16.0751 2.46958L17.1088 4.64175C17.1117 4.64769 17.1145 4.65363 17.1175 4.65952C17.5177 5.45983 18.3221 5.95698 19.2169 5.95698H22.9531C23.5131 5.95698 23.9688 6.41259 23.9688 6.97261V20.6835Z"
      fill={color}
    />
    <path d="M21.9375 7.98828H19.9062V10.0195H21.9375V7.98828Z" fill={color} />
  </svg>
);

export const UploadImg = ({ color = "white" }) => (
  <svg
    width="44"
    height="30"
    viewBox="0 0 44 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5131 29.2602H19.0657C18.0634 29.2602 17.2499 28.4745 17.2499 27.5102V18.7602H12.7105C12.3437 18.7602 12.0114 18.5467 11.8716 18.2195C11.7318 17.8922 11.8098 17.516 12.0677 17.2657L21.1466 8.5157C21.5007 8.17445 22.0763 8.17445 22.4304 8.5157L31.5093 17.2657C31.769 17.516 31.8471 17.8922 31.7055 18.2195C31.5638 18.5467 31.2352 18.7602 30.8684 18.7602H26.3289V27.5102C26.3289 28.4745 25.5154 29.2602 24.5131 29.2602Z"
      fill={color}
    />
    <path
      d="M8.17287 27.9475C8.13837 27.9475 8.10568 27.9458 8.06937 27.9422C3.46997 27.4505 0 23.7125 0 19.25C0 14.6265 3.73871 10.8308 8.45432 10.521C9.71084 4.473 15.3126 0 21.7895 0C26.8755 0 31.5602 2.7615 33.8699 7.077C39.3572 7.63175 43.5789 12.1135 43.5789 17.5C43.5789 22.19 40.3178 26.3375 35.6512 27.5835C35.1646 27.7113 34.6671 27.4383 34.5345 26.9728C34.4001 26.5073 34.6834 26.0243 35.1664 25.8965C39.0504 24.8605 41.7632 21.406 41.7632 17.5C41.7632 12.8678 38.0172 9.03875 33.2344 8.78325C32.8985 8.76575 32.6025 8.5715 32.4609 8.27925C30.5398 4.31375 26.3526 1.75 21.7895 1.75C15.9517 1.75 10.9365 5.94125 10.123 11.4975C10.0595 11.928 9.67634 12.25 9.22421 12.25C5.07332 12.25 1.81579 15.3895 1.81579 19.25C1.81579 22.82 4.59032 25.809 8.27274 26.2028C8.77026 26.257 9.12979 26.6893 9.0735 27.1688C9.02266 27.6168 8.62863 27.9475 8.17287 27.9475Z"
      fill={color}
    />
  </svg>
);

export const HidePasswordImg = () => (
  <svg
    width="15"
    height="8"
    viewBox="0 0 15 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.1279 0.161446C1.48754 -0.0440614 1.94568 0.080886 2.15119 0.440524C2.53605 1.11403 2.96984 1.68713 3.43537 2.16336C4.18227 2.92743 5.01265 3.44422 5.8637 3.72993C7.02905 4.12115 8.27373 4.09078 9.44944 3.61417C9.45872 3.61012 9.46811 3.60624 9.47763 3.60253C9.47917 3.60193 9.48072 3.60133 9.48226 3.60074C10.2159 3.29783 10.9221 2.8207 11.5646 2.16336C12.0302 1.68713 12.464 1.11402 12.8488 0.440524C13.0543 0.080886 13.5125 -0.0440614 13.8721 0.161446C14.2317 0.366953 14.3567 0.825093 14.1512 1.18473C13.8512 1.70965 13.5213 2.18894 13.166 2.62151L14.7431 3.99749C15.0552 4.2698 15.0874 4.74358 14.8151 5.05569C14.5428 5.36781 14.069 5.40007 13.7569 5.12776L12.1198 3.69944C11.6704 4.08867 11.1953 4.41582 10.7025 4.6799L11.5738 6.91525C11.7242 7.30118 11.5333 7.73599 11.1474 7.88641C10.7614 8.03684 10.3266 7.84592 10.1762 7.45999L9.31294 5.2452C8.25184 5.54801 7.147 5.58297 6.06653 5.3417L5.19404 7.47189C5.03705 7.85519 4.59904 8.03865 4.21574 7.88166C3.83243 7.72466 3.64897 7.28666 3.80597 6.90335L4.64506 4.85469C4.02575 4.56456 3.43292 4.17842 2.8801 3.69948L1.24308 5.12776C0.930965 5.40007 0.45719 5.36781 0.184874 5.05569C-0.0874423 4.74358 -0.0551781 4.2698 0.256938 3.99749L1.83401 2.62151C1.47866 2.18894 1.14878 1.70965 0.848827 1.18473C0.64332 0.825093 0.768267 0.366953 1.1279 0.161446Z"
      fill="#3A4D54"
    />
  </svg>
);

export const ShowPasswordImg = () => (
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7046 4.70758C14.5742 4.52385 11.4676 0.208811 7.49993 0.208811C3.53226 0.208811 0.42554 4.52385 0.295299 4.7074C0.171815 4.88171 0.171815 5.11812 0.295299 5.29242C0.42554 5.47615 3.53226 9.79119 7.49993 9.79119C11.4676 9.79119 14.5742 5.47613 14.7046 5.29257C14.8282 5.11829 14.8282 4.88171 14.7046 4.70758ZM7.49993 8.79991C4.57732 8.79991 2.04603 5.93594 1.29672 4.99966C2.04506 4.06256 4.57105 1.20009 7.49993 1.20009C10.4224 1.20009 12.9535 4.06356 13.7031 5.00034C12.9548 5.93741 10.4288 8.79991 7.49993 8.79991Z"
      fill="#3A4D54"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.32914 2.22858C3.63247 1.11456 5.44652 0 7.49993 0C9.55334 0 11.3674 1.11456 12.6707 2.2286C13.9776 3.34573 14.7981 4.48558 14.8682 4.58435C15.044 4.83192 15.0439 5.16817 14.8682 5.41579C14.7982 5.51438 13.9776 6.65428 12.6707 7.77141C11.3674 8.88543 9.55334 10 7.49993 10C5.44652 10 3.63247 8.88544 2.32914 7.7714C1.02221 6.65428 0.201678 5.51443 0.131596 5.41557C-0.0438426 5.16792 -0.0438767 4.83195 0.131562 4.58431C0.201588 4.48562 1.0222 3.34568 2.32914 2.22858ZM0.459003 5.16928C0.387507 5.06832 0.387518 4.93145 0.459037 4.83049L0.459003 5.16928ZM0.459037 4.83049C0.519942 4.74467 1.31774 3.63574 2.58802 2.54997C3.86253 1.46058 5.58567 0.417623 7.49993 0.417623C9.41418 0.417623 11.1373 1.46058 12.4118 2.54999C13.6827 3.63631 14.4806 4.74584 14.5409 4.83081C14.6124 4.93146 14.6125 5.06835 14.541 5.16926C14.4806 5.25423 13.6827 6.36372 12.4118 7.45002C11.1373 8.53942 9.41418 9.58238 7.49993 9.58238C5.58567 9.58238 3.86253 8.53942 2.58802 7.45001C1.31735 6.36389 0.519428 5.25452 0.459003 5.16928M1.5609 4.99952C1.96689 5.49227 2.72518 6.33629 3.70398 7.08309C4.78021 7.90423 6.10115 8.5911 7.49993 8.5911C8.90192 8.5911 10.2231 7.90451 11.2986 7.08374C12.2767 6.33725 13.0336 5.49345 13.439 5.00047C13.0329 4.50755 12.2745 3.66349 11.2957 2.91672C10.2195 2.09565 8.89864 1.4089 7.49993 1.4089C6.09793 1.4089 4.77672 2.09548 3.70129 2.91624C2.72317 3.66274 1.96627 4.50653 1.5609 4.99952ZM3.45995 2.58068C4.56682 1.73593 5.97304 0.991275 7.49993 0.991275C9.02368 0.991275 10.4296 1.73626 11.537 2.58112C12.6471 3.4281 13.4792 4.39226 13.8596 4.86752L13.9657 5.0002L13.8597 5.133C13.48 5.60843 12.6495 6.57249 11.5399 7.41931C10.433 8.26406 9.02681 9.00873 7.49993 9.00873C5.9761 9.00873 4.57009 8.26361 3.46269 7.41869C2.35252 6.57165 1.52046 5.60749 1.14031 5.13249L1.03412 4.99981L1.14017 4.867C1.51986 4.39156 2.35038 3.4275 3.45995 2.58068Z"
      fill="#3A4D54"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.41036 4.99996C4.41036 3.24488 5.79619 1.81729 7.49993 1.81729C9.20366 1.81729 10.5895 3.24488 10.5895 4.99996C10.5895 6.75504 9.20366 8.18263 7.49993 8.18263C5.79619 8.18263 4.41036 6.75504 4.41036 4.99996Z"
      fill="#3A4D54"
    />
  </svg>
);

export const ZoomSmallImg = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.25"
      y="1.25"
      width="10.5"
      height="10.5"
      rx="2.75"
      stroke="white"
      strokeWidth="2.5"
    />
  </svg>
);

export const ZoomBigImg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.25"
      y="1.25"
      width="16.5"
      height="16.5"
      rx="2.75"
      stroke="white"
      strokeWidth="2.5"
    />
  </svg>
);

export const FitImageImg = () => (
  <svg
    width="22"
    height="25"
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.379 0.952467C10.586 0.729573 10.793 0.655273 11.0691 0.655273C11.3451 0.655273 11.5521 0.878169 11.6211 0.952467C11.8281 1.17536 11.8972 1.39826 11.8972 1.69545V6.15334L13.0013 4.96457C13.4153 4.51878 14.0364 4.59308 14.3815 4.96457C14.7955 5.41036 14.7265 6.07904 14.3815 6.45053L11.6901 9.34816C11.2761 9.79395 10.655 9.71965 10.31 9.34816L7.61862 6.45053C7.20457 6.00474 7.27358 5.33606 7.61862 4.96457C8.03267 4.51878 8.65375 4.59308 8.99879 4.96457L10.1029 6.15334V1.69545C10.1029 1.39826 10.2409 1.10106 10.379 0.952467ZM10.379 24.3581C10.586 24.581 10.793 24.6553 11.0691 24.6553C11.3451 24.6553 11.5521 24.4324 11.6211 24.3581C11.8281 24.1352 11.8972 23.9123 11.8972 23.6151V19.1572L13.0013 20.346C13.4153 20.7918 14.0364 20.7175 14.3815 20.346C14.7955 19.9002 14.7265 19.2315 14.3815 18.86L11.6901 15.9624C11.2761 15.5166 10.655 15.5909 10.31 15.9624L7.61862 18.86C7.20457 19.3058 7.27358 19.9745 7.61862 20.346C8.03267 20.7918 8.65375 20.7175 8.99879 20.346L10.1029 19.1572V23.6151C10.1029 23.9123 10.2409 24.2095 10.379 24.3581ZM0 12.5802C0 12.8813 0.0681067 13.1071 0.272427 13.333C0.40864 13.4835 0.681066 13.6341 0.953493 13.6341L5.03989 13.6341L3.95019 14.8386C3.60965 15.215 3.54155 15.8926 3.95019 16.3443C4.29072 16.7207 4.90368 16.796 5.31232 16.3443L7.96848 13.4083C8.30902 13.0319 8.37712 12.3543 7.96848 11.9026L5.31232 8.96662C4.97179 8.59021 4.35883 8.51493 3.95019 8.96662C3.60965 9.34303 3.54155 10.0206 3.95019 10.4723L5.03989 11.6768H0.953493C0.681067 11.6768 0.476747 11.7521 0.272427 11.9779C0.20432 12.0532 0 12.279 0 12.5802ZM21.7276 13.333C21.9319 13.1071 22 12.8813 22 12.5802C22 12.279 21.7957 12.0532 21.7276 11.9779C21.5233 11.7521 21.3189 11.6768 21.0465 11.6768H16.9601L18.0498 10.4723C18.4585 10.0206 18.3903 9.34303 18.0498 8.96662C17.6412 8.51493 17.0282 8.59021 16.6877 8.96662L14.0315 11.9026C13.6229 12.3543 13.691 13.0319 14.0315 13.4083L16.6877 16.3443C17.0963 16.796 17.7093 16.7207 18.0498 16.3443C18.4585 15.8926 18.3903 15.215 18.0498 14.8386L16.9601 13.6341L21.0465 13.6341C21.3189 13.6341 21.5914 13.4835 21.7276 13.333Z"
      fill="white"
    />
  </svg>
);

export const FitOutImageImg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 0H4.5C2 0 0 2 0 4.5V19.5C0 22 2 24 4.5 24H19.5C22 24 24 22 24 19.5V4.5C24 2 22 0 19.5 0ZM21.9 19.5C21.9 20.8 20.8 21.9 19.5 21.9H4.5C3.2 21.9 2.1 20.8 2.1 19.5V4.5C2.1 3.2 3.2 2.1 4.5 2.1H19.5C20.8 2.1 21.9 3.2 21.9 4.5V19.5Z"
      fill="white"
    />
    <path
      d="M18.1 4.8999H14.2C13.7 4.8999 13.3 5.2999 13.3 5.7999V5.8999C13.4 6.3999 13.7 6.6999 14.2 6.6999H15.8L12.8 9.6999C12.6 9.8999 12.5 10.0999 12.5 10.3999C12.5 10.5999 12.6 10.8999 12.8 11.0999C13 11.2999 13.2 11.3999 13.5 11.3999C13.7 11.3999 14 11.2999 14.2 11.0999L17.2 8.0999V9.6999C17.2 10.1999 17.6 10.6999 18.2 10.6999C18.7 10.6999 19.2 10.2999 19.2 9.6999V5.7999C19.1 5.2999 18.7 4.8999 18.1 4.8999Z"
      fill="white"
    />
    <path
      d="M11.2 12.8C11 12.6 10.8 12.5 10.5 12.5C10.3 12.5 9.99999 12.6 9.79999 12.8L6.79999 15.8V14.2C6.79999 13.7 6.39999 13.2 5.79999 13.2C5.29999 13.2 4.79999 13.6 4.79999 14.2V18.1C4.79999 18.6 5.19999 19.1 5.79999 19.1H9.69999C10.2 19.1 10.7 18.7 10.7 18.1C10.7 17.6 10.3 17.1 9.69999 17.1H8.09999L11.1 14.1C11.3 13.9 11.4 13.7 11.4 13.4C11.4 13.3 11.4 13 11.2 12.8Z"
      fill="white"
    />
  </svg>
);

export const FlipImageImg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.4546 19.6365H15.2728V21.8183H17.4546V19.6365Z" fill="white" />
    <path
      d="M2.18182 4.36367V19.6364C2.18182 20.8419 3.15817 21.8183 4.36366 21.8183H8.72728V19.6364H4.36361V4.36367H8.72723V2.18188H4.36361C3.15817 2.18188 2.18182 3.15823 2.18182 4.36367Z"
      fill="white"
    />
    <path
      d="M13.0909 22.9091V1.09091C13.0909 0.488417 12.6025 0 12 0C11.3975 0 10.9091 0.488416 10.9091 1.09091V22.9091C10.9091 23.5116 11.3975 24 12 24C12.6025 24 13.0909 23.5116 13.0909 22.9091Z"
      fill="white"
    />
    <path
      d="M19.6364 2.18188V4.36372H21.8182C21.8182 3.15823 20.8418 2.18188 19.6364 2.18188Z"
      fill="white"
    />
    <path d="M21.8182 10.9092H19.6364V13.091H21.8182V10.9092Z" fill="white" />
    <path d="M17.4546 2.18188H15.2728V4.36372H17.4546V2.18188Z" fill="white" />
    <path d="M21.8182 6.54541H19.6364V8.72725H21.8182V6.54541Z" fill="white" />
    <path d="M21.8182 15.2727H19.6364V17.4545H21.8182V15.2727Z" fill="white" />
    <path
      d="M19.6364 21.8183C20.8418 21.8183 21.8182 20.842 21.8182 19.6365H19.6364V21.8183Z"
      fill="white"
    />
  </svg>
);

export const RotateImageImg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0005 23.6008C18.6173 23.6008 24 18.2175 24 11.6008C24 8.50296 22.7984 5.5402 20.677 3.31681C20.677 3.31681 20.986 2.62177 21.3686 1.76437C21.7503 0.906972 21.2009 0.301942 20.1407 0.412432L13.9315 1.0629C12.8712 1.17362 12.519 1.96275 13.1451 2.82549L16.813 7.87863C17.4397 8.74121 18.2125 8.84464 18.5401 8.10911L19.1333 6.77788C20.0885 8.19135 20.6224 9.86417 20.6224 11.6008C20.6224 16.3558 16.7546 20.223 12.0006 20.223C7.24577 20.223 3.37773 16.3553 3.37773 11.6008C3.37773 10.103 3.76696 8.62836 4.50438 7.33677C4.96666 6.52653 4.68486 5.49523 3.87463 5.03303C3.06415 4.57035 2.03333 4.85254 1.57065 5.66325C0.543272 7.46343 0 9.51653 0 11.6007C0 18.2175 5.38343 23.6008 12.0005 23.6008Z"
      fill="white"
    />
  </svg>
);

export const LockViewImg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6061 5.83758V3.60606C10.6061 1.61636 8.9897 0 7 0C5.0103 0 3.39394 1.61636 3.39394 3.60606V5.83758C2.60485 6.70303 2.12121 7.85697 2.12121 9.12121C2.12121 11.8109 4.3103 14 7 14C9.6897 14 11.8788 11.8109 11.8788 9.12121C11.8788 7.85697 11.3952 6.70727 10.6061 5.83758ZM7.86121 9.40545V10.5509C7.86121 11.0261 7.47515 11.4121 7 11.4121C6.52485 11.4121 6.13879 11.0261 6.13879 10.5509V9.40545C5.79091 9.14242 5.56606 8.72667 5.56606 8.26C5.56606 7.47091 6.20667 6.82606 7 6.82606C7.79333 6.82606 8.43394 7.46667 8.43394 8.26C8.43394 8.73091 8.20485 9.14667 7.86121 9.40545ZM9.33333 4.83636C8.64182 4.45879 7.84424 4.24242 7 4.24242C6.15576 4.24242 5.35818 4.45879 4.66667 4.83636V3.60606C4.66667 2.32061 5.71455 1.27273 7 1.27273C8.28545 1.27273 9.33333 2.32061 9.33333 3.60606V4.83636Z"
      fill="#3A4D54"
      fillOpacity="0.25"
    />
  </svg>
);